import React from 'react';
import styled from 'styled-components';

export const Review = ({text, author}) => {
  return (
    <Container>
        <div className='stars'>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
        </div>
        <p>{text}<br/><br /> - {author}</p>
    </Container>
  )
}

const Container = styled.div`
    border: 1px solid #fff;
    border-radius: 20px;
    padding: 20px;
    width: 70%;
    margin: 1.5rem auto 0 auto;

    div.stars{
        i{
            color: #cbb16d;
        }
    }
    p{
        margin-top: .6rem;
        color: #fff;
        font-size: 1rem;
        font-family: "Roboto", sans-serif;
    }
`;
